<template>
	<div v-if="!sptt.paid" @click.prevent="handleCheckout">
		<slot />
	</div>
</template>

<script>
import { useStore } from "vuex";

import { loadStripe } from "@stripe/stripe-js";
import User from "@/api/User";

// Make sure to call `loadStripe` outside of a component’s render to avoid
// recreating the `Stripe` object on every render.
const stripePromise = loadStripe(process.env.VUE_APP_STRIPE_PK);

export default {
	name: "Checkout",
	setup() {
		const store = useStore();

		const handleCheckout = async (event) => {
			// When the customer clicks on the button, redirect them to Checkout.
			const stripe = await stripePromise;

			User.stripeSession()
				.then(function ({data}) {
					return stripe.redirectToCheckout({ sessionId: data.id });
				})
				.then(function (result) {
					// If `redirectToCheckout` fails due to a browser or network
					// error, you should display the localized error message to your
					// customer using `error.message`.
					if (result.error) {
						alert(result.error.message);
					}
				});
		};

		return {
			sptt: store.getters.sptt,
			handleCheckout,
		};
	},
};
</script>
